// src/components/admin/AddPhraseForm.js
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api'; // ✅ Используем единый api

const AddPhraseForm = ({ themeId, projectId, absolutelyEverything, onAdd }) => {
  const { user } = useAuth();
  const [phraseText, setPhraseText] = useState('');
  const [group, setGroup] = useState(1);
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phraseText.trim()) return;

    try {
      const response = await api.post('/admin/analytics/phrase', {
        text: phraseText.trim(),
        theme_id: themeId,
        project_id: projectId,
        group: absolutelyEverything ? Number(group) : undefined,
      });

      // Успешно добавлено
      setPhraseText('');
      setGroup(1);
      onAdd(); // Обновить список фраз

      // Показать сообщение из ответа (если нужно)
      const message = response.data?.message || 'Фраза добавлена';
      // alert(message);
    } catch (err) {
      console.error('Ошибка при добавлении фразы:', err);
      const message =
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Не удалось добавить фразу';
      alert(message);
    }
  };

  if (!roleNames.has('admin')) return null;

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      {/* Поля формы */}
      <div className="input-group mb-2">
        <input
          type="text"
          name="phrase_text"
          className="form-control"
          placeholder="Введите новую фразу"
          value={phraseText}
          onChange={(e) => setPhraseText(e.target.value)}
          required
        />
      </div>

      {/* Поле "Группа" — только если absolutely_everything = true */}
      {absolutelyEverything && (
        <div className="input-group mb-2">
          <label className="input-group-text" htmlFor={`phrase-group-${themeId}`}>
            Группа
          </label>
          <input
            type="number"
            id={`phrase-group-${themeId}`}
            name="group"
            className="form-control"
            value={group}
            onChange={(e) => setGroup(e.target.value)}
            min="1"
            required
          />
          <small className="text-muted d-block mt-1">
            Фразы одной группы должны присутствовать все
          </small>
        </div>
      )}

      <button type="submit" className="btn btn-success">
        Добавить фразу
      </button>
    </form>
  );
};

export default AddPhraseForm;





